import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthQuery, useAuthMutation } from "@rentablo/api";
import { loadProperties, updateProperties } from "@api";

export const SECURITY_KEY = "securityDashboardSettings";
export const FUNDS_KEY = "fundDashboardSettings";

export const useSettings = <V>(propKey: string) => {
  const queryClient = useQueryClient();
  const { data, isLoading } = useAuthQuery(
    ["my-security-dashboard-settings", propKey],
    ({ token }) => loadProperties(token, propKey),
    { staleTime: 1000 * 60 * 5 }
  );

  const { mutate: update } = useAuthMutation<
    any,
    unknown,
    {
      values: V[];
      propKey: string;
    },
    unknown
  >(updateProperties, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["my-security-dashboard-settings"],
      });
    },
  });

  const handleSave = useCallback(
    (values: V[]) => {
      update({ values, propKey });
    },
    [update, propKey]
  );

  return {
    settings: data?.value?.values as V[] | undefined,
    save: handleSave,
    isLoading,
  };
};
